import { render } from "./InvestmentsTopup.vue?vue&type=template&id=35a9641a"
import script from "./InvestmentsTopup.vue?vue&type=script&lang=js"
export * from "./InvestmentsTopup.vue?vue&type=script&lang=js"
script.render = render

export default script